import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    Box,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
        borderRadius: 8,
        minWidth: 400,
    },
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '16px 20px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '4px',
}));

const StyledDialogContent = styled(DialogContent)({
    padding: '20px',
    '&.MuiDialogContent-root': {
        paddingTop: '24px',
    },
});
const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
    padding: '12px 20px',
    borderTop: `1px solid ${theme.palette.divider}`,
    gap: '8px',
}));

const LsDialog = ({
    open,
    onClose,
    title,
    subtitle,
    children,
    actions,
    maxWidth = 'sm',
    fullWidth = true,
    ...props
}) => {
    return (
        <StyledDialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            {...props}
        >
            <StyledDialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography variant="body2" color="text.secondary">
                                {subtitle}
                            </Typography>
                        )}
                    </Box>
                    {onClose && (
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            size="small"
                            sx={{ color: 'text.secondary', mt: -0.5 }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    )}
                </Box>
            </StyledDialogTitle>
            <StyledDialogContent>{children}</StyledDialogContent>
            {actions && <StyledDialogActions>{actions}</StyledDialogActions>}
        </StyledDialog>
    );
};

export default LsDialog;